import { isEmpty, isFunction } from 'lodash';
import URI from 'urijs';
import { callGetApi, callPostApi } from './apiCallerProxy';
import { DEFAULT_REQUEST_HEADERS } from './defaultRequestHeaders';

// queryParams is an object. each key is a field and the value is the requested value.
// example: {start_date: '2016-12-17', end_date: '2016-12-27'}
const reportsApiCreator =
    apiCacheKey =>
    (reportEndPoint, accountId, queryParams, getCustomHeaders = () => DEFAULT_REQUEST_HEADERS, onResponse) => {
        const url = URI(
            isFunction(reportEndPoint)
                ? reportEndPoint(accountId, queryParams)
                : `/${accountId}/reports/${reportEndPoint}`
        );

        if (queryParams) {
            const { postBody: _postBody, ...urlQueryParams } = queryParams;
            url.addSearch(urlQueryParams);
        }

        if (queryParams?.postBody) {
            if (isEmpty(queryParams.postBody.columns.values)) {
                return Promise.resolve();
            }
            return callPostApi(url.toString(), queryParams.postBody, {
                singleRequestCacheKey: apiCacheKey,
                headers: getCustomHeaders(),
                onResponse,
            });
        }

        return callGetApi(url.toString(), {
            singleRequestCacheKey: apiCacheKey,
            headers: getCustomHeaders(),
            onResponse,
        });
    };

export default reportsApiCreator;
